// extracted by mini-css-extract-plugin
export var container = "loader-module--container--P5GSR";
export var loader = "loader-module--loader--OKIsF";